import { ServiceFetch } from '../service-fetch'

export default class InvoiceCustomerDepositModel extends ServiceFetch {
    getInvoiceCustomerDepositBy = (data) => this.authFetch({
        url: 'invoice-customer-deposit/getInvoiceCustomerDepositBy',
        method: 'POST',
        body: JSON.stringify(data),
    })
}